import getAmountOfGlassAreas from 'components/configurator/services/getAmountOfGlassAreas';
import getDoorsFromWallParts from 'components/configurator/services/getDoorsFromWallParts';
import handleFirstAndLastDoorSettings from 'components/configurator/services/handleFirstAndLastDoorSettings';
import IGlassArea from 'components/interfaces/IGlassArea';
import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';

import IValidationError from './IValidationError';
import validateDoor from './doors/validateDoor';
import validateGlassArea from './validateGlassArea';

const validateGlassWall = (
  wall: IWall,
  wallMetaData: IWallMetaData,
  glassAreas: IGlassArea[]
): IValidationError[] => {
  let validationErrors = [];

  if (wall.openingHeight === 0) {
    validationErrors.push({
      message: 'Opening height should not be zero',
      property: 'openingHeight',
    });
  }

  const doors = handleFirstAndLastDoorSettings(
    getDoorsFromWallParts(wall),
    wall
  );

  let previousDoor = null;
  for (let i = 0; i < doors.length; ++i) {
    validationErrors = [
      ...validationErrors,
      ...validateDoor(doors[i], previousDoor, wall).map((error) => ({
        ...error,
        message: `Door ${i + 1}: ${error.message}`,
      })),
    ];

    previousDoor = doors[i];
  }

  const amountOfGlassAreas = getAmountOfGlassAreas(doors, wall);

  for (let i = 0; i < glassAreas.length; ++i) {
    if (i + 1 > amountOfGlassAreas) {
      continue;
    }

    validationErrors = [
      ...validationErrors,
      ...validateGlassArea(
        glassAreas[i],
        wallMetaData.glassAreas[i],
        i,
        wall
      ).map((error) => ({
        ...error,
        message: `Glass area ${i + 1}: ${error.message}`,
      })),
    ];
  }

  return validationErrors;
};

export default validateGlassWall;
